import CampoTexto from '../../components/Formulario/CampoTexto';
import Grid, { GridItem } from '../../components/layout/Grid';
import axios from 'axios';
import { useQuery } from 'react-query';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import CampoSenha from '../../components/Formulario/CampoSenha';
import { DiaExpediente } from './DiaExpediente';
import Botao from '../../components/Botao';
import {
  mdiCheckboxMarked,
  mdiCheckboxBlankOutline,
  mdiEmail,
  mdiInformationSlabCircle,
  mdiPhone,
  mdiSend,
  mdiTagPlus,
  mdiTrashCan,
  mdiWhatsapp,
} from '@mdi/js';
import AlertBox from '../../components/layout/AlertBox';
import Icon from '../../components/Icon';
import BotaoPerigoso from '../../components/BotaoPerigoso';
import IconeCanal from '../../components/layout/IconeCanal';
import HBox from '../../components/layout/HBox';
import VBox from '../../components/layout/VBox';
import CampoNumero from '../../components/Formulario/CampoNumero';
import CampoTelefone from '../../components/Formulario/CampoTelefone';
import { Tooltip } from '../../components/layout/Tooltip';
import { parseTelefone, parseTelefoneZap } from '@tera/shared/src/lib';
import Marcadores from '@/components/layout/Marcadores';
import { useState } from 'react';
import { CampoPersonalizacao } from '@/components/Formulario/CampoPersonalizacao';
import { contatoTipoOptions } from './contatoTipoOptions';
import Modal from '@/components/layout/Modal';
import { FormEmpresa } from '../empresa/FormEmpresa';
import { CampoSeletorEmpresa } from '@/components/CampoSeletorEmpresa';
import { toast } from 'react-toastify';
import { queryClient } from '@/queryClient';
import CampoCheckbox from '@/components/Formulario/CampoCheckbox';
import CampoMemo from '@/components/Formulario/CampoMemo';

export const FormCliente = ({
  value,
  onChange,
  fieldErrors,
}: {
  value: any;
  onChange: any;
  fieldErrors: any;
}) => {
  const qCustomize = useQuery('cliente/meta', async () => {
    const res = await axios.get('/api/cliente/meta', {
      withCredentials: true,
    });

    return res.data.result;
  });

  const qTags = useQuery('tags', async () => {
    const { data } = await axios.get('/api/marcador/box');
    return data?.result ?? [];
  });

  const qGrupos = useQuery('cliente_grupo/box', async () => {
    const { data } = await axios.get('/api/cliente_grupo/box');
    return data?.result ?? [];
  });
  const gruposOptions = qGrupos.data?.result?.map((it: any) => ({
    id: it.id,
    label: it.nome,
  }));

  const qUsuarios = useQuery('usuario/box', async () => {
    const { data } = await axios.get('/api/usuario/box');
    return data?.result ?? [];
  });
  const usuariosOptions = qUsuarios.data?.map((it: any) => ({
    id: it.id,
    label: it.nome,
    group: it.grupo?.nome,
  }));

  const optionsTags = qTags.data
    ?.filter((tag: any) => ['qualquer', 'cliente'].includes(tag.local))
    ?.map((tag: any) => ({
      id: tag.id,
      label: tag.nome,
    }));

  const estiloFilaOptions = [
    { id: 'unica', label: 'Sequencial' },
    { id: 'paralela', label: 'Paralela' },
  ];

  const addNewContato = (tipo: string, valor: string = '') => {
    // Verifica se já existe um contato com o mesmo tipo e valor
    const contatoExistente = value?.contatos?.find(
      (contato: any) => contato.tipo === tipo && contato.valor === valor && !contato._paraExclusao
    );

    if (contatoExistente) return; // Não adiciona duplicados

    // Verifica se existe um contato marcado para exclusão com o mesmo tipo e valor
    const contatoParaExclusao = value?.contatos?.find(
      (contato: any) => contato.tipo === tipo && contato.valor === valor && contato._paraExclusao
    );

    if (contatoParaExclusao) {
      // Se existir, remove a marca de exclusão
      const newContatos = [...(value?.contatos ?? [])];
      const idx = newContatos.findIndex((c: any) => c === contatoParaExclusao);
      if (idx !== -1) {
        newContatos[idx] = { ...newContatos[idx], _paraExclusao: false };
        onChange({
          ...value,
          contatos: newContatos,
        });
      }
      return;
    }

    onChange({
      ...value,
      contatos: [{ tipo, valor }, ...(value?.contatos ?? [])],
    });
  };

  // Verifica se existe um contato de whatsapp correspondente ao número de telefone
  const temWhatsAppParaTelefone = (telefoneValor: string) => {
    const whatsappValor = parseTelefoneZap(telefoneValor);
    return value?.contatos?.some(
      (contato: any) => contato.tipo === 'whatsapp' && contato.valor === whatsappValor && !contato._paraExclusao
    );
  };

  // Verifica se um contato de whatsapp já é representado por um contato de telefone
  // (par criado via checkbox "tem WhatsApp?"), para não duplicar a linha na lista
  const temTelefoneParaWhatsApp = (whatsappValor: string) => {
    return value?.contatos?.some(
      (contato: any) =>
        contato.tipo === 'telefone' &&
        !contato._paraExclusao &&
        parseTelefoneZap(contato.valor) === whatsappValor,
    );
  };

  // Adiciona ou remove o contato de whatsapp associado ao telefone
  const toggleWhatsAppParaTelefone = (telefoneValor: string, isChecked: boolean) => {
    if (isChecked) {
      // Adiciona WhatsApp
      addNewContato('whatsapp', parseTelefoneZap(telefoneValor));
    } else {
      // Marca WhatsApp para exclusão
      const whatsappValor = parseTelefoneZap(telefoneValor);
      const contatos = [...(value?.contatos ?? [])];
      const idx = contatos.findIndex(
        (contato: any) => contato.tipo === 'whatsapp' && contato.valor === whatsappValor && !contato._paraExclusao
      );

      if (idx !== -1) {
        contatos[idx] = { ...contatos[idx], _paraExclusao: true };
        onChange({
          ...value,
          contatos: contatos,
        });
      }
    }
  };

  const [newTag, setNewTag] = useState<string>('');
  const [objEmpresa, setObjEmpresa] = useState<any>(null);
  const [objEmpresaFieldErrors, setObjEmpresaFieldErrors] = useState<Record<string, any>>({});

  const handleOpenEmpresaModal = () => {
    setObjEmpresa({});
  }

  const handleCloseEmpresaModal = () => {
    setObjEmpresa(null);
  }

  const empresaMutation = useQuery('empresa/mutate', async () => {
    if (!objEmpresa) return;

    setObjEmpresaFieldErrors({});

    try {
      const result = await axios.post(`/api/empresa`, objEmpresa, {
        withCredentials: true,
      });

      setObjEmpresaFieldErrors({});
      queryClient.invalidateQueries('empresa/box');
      setObjEmpresa(null);

      toast.success('Empresa adicionada com sucesso', {
        position: 'top-center',
        autoClose: 5000,
      });

      // Atualiza o cliente para usar a nova empresa
      onChange({
        ...value,
        empresa_id: result.data.result.id
      });

      return result.data;
    } catch (err: any) {
      if (err.response?.status === 422) {
        setObjEmpresaFieldErrors(err.response?.data?.fieldErrors ?? {});
      }
      toast.warning(err.response?.data?.msg ?? 'Erro desconhecido', {
        position: 'top-center',
        autoClose: 5000,
      });
      throw err;
    }
  }, {
    enabled: false,
  });

  const handleConfirmEmpresa = () => {
    empresaMutation.refetch();
  }

  const idsMarcadores = value?.marcadores?.map((it: any) => it?.id)?.filter(Boolean);

  return (
    <Grid>
      <Modal
        instanceId='modal-empresa-new'
        title="Nova Empresa"
        show={objEmpresa != null}
        onClose={handleCloseEmpresaModal}
        onConfirm={handleConfirmEmpresa}
        confirmProps={{
          label: 'Adicionar'
        }}
      >
        <FormEmpresa value={objEmpresa} onChange={setObjEmpresa} fieldErrors={objEmpresaFieldErrors} />
      </Modal>
      <div style={{ position: 'absolute', height: 0 }}>
        <input
          type="text"
          name="username"
          style={{
            height: 0,
            width: 0,
            border: 'none',
            outline: 'none',
            margin: 0,
            padding: 0,
          }}
        />
        <input
          type="password"
          name="password"
          style={{
            height: 0,
            width: 0,
            border: 'none',
            outline: 'none',
            margin: 0,
            padding: 0,
          }}
        />
      </div>
      <GridItem sm={12} md={8}>
        <CampoTexto
          instanceId="nome"
          value={value?.nome ?? ''}
          onChange={v => onChange({ ...value, nome: v })}
          label="Nome"
          error={fieldErrors?.nome}
        />
      </GridItem>

      <GridItem sm={12} md={4}>
        <CampoSeletor
          instanceId='grupo_id'
          options={gruposOptions}
          value={value?.grupo_id}
          onChange={v => onChange({ ...value, grupo_id: v })}
          label="Grupo"
          error={fieldErrors?.grupo_id}
        />
      </GridItem>

      <GridItem sm={12} md={6}>
        <CampoSeletorEmpresa
          instanceId="empresa"
          nullable
          value={value?.empresa_id ?? ''}
          onChange={v => onChange({ ...value, empresa_id: v })}
          label="Empresa"
          onNovaEmpresa={handleOpenEmpresaModal}
          error={fieldErrors?.empresa}
        />
      </GridItem>

      <GridItem sm={12} md={6}>
        <CampoSeletor
          instanceId="estado"
          noSearch
          value={value?.estado}
          onChange={v => onChange({ ...value, estado: v })}
          label="Situação"
          options={[
            { id: 'ativo', label: 'Ativo' },
            {
              id: 'bloqueado_campanha',
              label: 'Bloqueados para campanhas',
            },
            { id: 'bloqueado', label: 'Bloqueado' },
          ]}
          error={fieldErrors?.estado}
        />
      </GridItem>

      <GridItem sm={12} md={4}>
        <CampoSeletor
          instanceId="usuario_reponsavel_id"
          value={value?.usuario_responsavel_id}
          onChange={v => onChange({ ...value, usuario_responsavel_id: v })}
          label="Atendente responsável"
          options={usuariosOptions}
          placeholder="(Não vinculado)"
          error={fieldErrors?.estado}
        />
      </GridItem>

      <GridItem sm={12} md={8}>
        <label>Marcadores</label>
        <HBox stretch>
          <CampoSeletor
            instanceId="marcadores"
            options={optionsTags?.filter(
              (it: any) => !idsMarcadores?.includes(it.id),
            ) ?? []}
            value={newTag}
            onChange={v => setNewTag(v as string)}
            noSearch
          />
          <div style={{ width: '72px', textAlign: 'end' }}>
            <Botao
              icon={mdiTagPlus}
              variant="outline-primary"
              onClick={() => {
                const tag = qTags.data?.find((it: any) => it.id === +newTag);
                if (!tag) return;
                onChange({
                  ...value,
                  marcadores: [...(value?.marcadores ?? []), tag],
                });
              }}
            />
          </div>
        </HBox>
        <div style={{ margin: '4px 0 8px 0' }}>
          <Marcadores
            ids={idsMarcadores}
            onRemove={(id: number) =>
              onChange({
                ...value,
                marcadores: value?.marcadores?.filter(
                  (it: any) => it.id !== id,
                ),
              })
            }
          />
        </div>
      </GridItem>
      <GridItem sm={12}>
        <p>Adicione quantos tipos de contato desejar:</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <HBox>
            <Botao
              variant="outline-primary"
              icon={mdiPhone}
              onClick={() => addNewContato('telefone')}
            >
              Telefone
            </Botao>
            <Botao
              variant="outline-primary"
              icon={mdiSend}
              onClick={() => addNewContato('telegram')}
            >
              Telegram
            </Botao>
            <Botao
              variant="outline-primary"
              icon={mdiEmail}
              onClick={() => addNewContato('email')}
            >
              E-mail
            </Botao>
          </HBox>

          <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
            {value?.contatos?.filter((contato: any) => !contato._paraExclusao).map((contato: any, idx: number) => {
              // Um whatsapp já representado por um telefone (par via checkbox) não duplica a linha.
              if (contato.tipo === 'whatsapp' && temTelefoneParaWhatsApp(contato.valor)) return null;

              return (
                <div
                  key={idx}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid var(--tc-color-gray-300)',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '4px',
                    alignItems: 'center',
                    padding: '1px 8px 1px 1px',
                  }}
                >
                  <div
                    style={{ flex: 1, background: 'var(--tc-color-gray-100)' }}
                  >
                    <CampoSeletor
                      instanceId={`contato-tipo-${idx}-${contato.tipo}`}
                      noSearch
                      noBorder
                      // Whatsapp/BSUID/username identificam a conversa (canal_cliente_id ou
                      // Fase 2 do BSUID): trocar o tipo aqui quebraria esse vínculo sem
                      // nenhum aviso, então fica travado.
                      disabled={['whatsapp', 'whatsapp_bsuid', 'whatsapp_username'].includes(contato.tipo)}
                      value={contato.tipo}
                      onChange={v => {
                        const newContatos = [...value.contatos];
                        const realIdx = value.contatos.findIndex((c: any) => c === contato);
                        if (realIdx !== -1) {
                          newContatos[realIdx].tipo = v;
                          onChange({ ...value, contatos: newContatos });
                        }
                      }}
                      options={contatoTipoOptions}
                    />
                  </div>

                  <div
                    style={{
                      borderLeft: '1px solid var(--tc-color-gray-300)',
                      flex: 1,
                      margin: 0,
                      padding: '0 8px',
                      border: 'none',
                      outline: 'none',
                      lineHeight: '40px',
                    }}
                  >
                    {['telegram'].includes(contato.tipo) && (
                      <CampoNumero
                        instanceId={`contato-valor-${idx}-${contato.tipo}`}
                        noBorder
                        value={contato.valor ?? ''}
                        onChange={v => {
                          const newContatos = [...value.contatos];
                          const realIdx = value.contatos.findIndex((c: any) => c === contato);
                          if (realIdx !== -1) {
                            newContatos[realIdx].valor = v;
                            onChange({ ...value, contatos: newContatos });
                          }
                        }}
                        mostrarSeparadorMilhar={false}
                        decimais={0}
                        somentePositivos={true}
                      />
                    )}

                    {contato.tipo === 'telefone' && (
                      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <CampoTelefone
                          instanceId={`contato-valor-${idx}-${contato.tipo}`}
                          noBorder
                          value={contato.valor ?? ''}
                          onChange={v => {
                            const newContatos = [...value.contatos];
                            const realIdx = value.contatos.findIndex((c: any) => c === contato);
                            if (realIdx !== -1) {
                              newContatos[realIdx].valor = v;
                              onChange({ ...value, contatos: newContatos });
                            }
                          }}
                        />

                        <div style={{ width: '48px', textAlign: 'center' }}>
                          <CampoCheckbox
                            instanceId={`contato-whatsapp-${idx}`}
                            value={temWhatsAppParaTelefone(contato.valor)}
                            onChange={checked => toggleWhatsAppParaTelefone(contato.valor, checked)}
                            disabled={!contato.valor}
                            size="small"
                          >
                            <Icon
                              path={mdiWhatsapp}
                              size={1.5}
                              color={'var(--tc-color-success)'}
                            />
                          </CampoCheckbox>
                        </div>
                      </div>
                    )}

                    {contato.tipo === 'whatsapp' && (
                      // O valor é guardado no formato "zap" (55 + DDD + 8 dígitos, sem o 9) usado
                      // no casamento conversa↔cliente (canal_cliente_id); converte só para exibir/editar.
                      <CampoTelefone
                        instanceId={`contato-valor-${idx}-${contato.tipo}`}
                        noBorder
                        value={parseTelefone(contato.valor ?? '')}
                        onChange={v => {
                          const newContatos = [...value.contatos];
                          const realIdx = value.contatos.findIndex((c: any) => c === contato);
                          if (realIdx !== -1) {
                            newContatos[realIdx].valor = parseTelefoneZap(v);
                            onChange({ ...value, contatos: newContatos });
                          }
                        }}
                      />
                    )}

                    {['whatsapp_bsuid', 'whatsapp_username'].includes(contato.tipo) && (
                      // Identidade auxiliar gerida automaticamente (Fase 1 do BSUID) — só leitura,
                      // não há como reformatar um ID opaco de forma segura para edição manual.
                      <CampoTexto
                        instanceId={`contato-valor-${idx}-${contato.tipo}`}
                        noBorder
                        disabled
                        value={contato.valor ?? ''}
                      />
                    )}

                    {contato.tipo === 'email' && (
                      <CampoTexto
                        instanceId={`contato-valor-${idx}-${contato.tipo}`}
                        noBorder
                        type="email"
                        value={contato.valor ?? ''}
                        onChange={v => {
                          const newContatos = [...value.contatos];
                          const realIdx = value.contatos.findIndex((c: any) => c === contato);
                          if (realIdx !== -1) {
                            newContatos[realIdx].valor = v;
                            onChange({ ...value, contatos: newContatos });
                          }
                        }}
                      />
                    )}

                    {contato.tipo === 'webchat' && (
                      <CampoTexto
                        instanceId={`contato-valor-${idx}-${contato.tipo}`}
                        noBorder
                        value={contato.valor ?? ''}
                        onChange={v => {
                          const newContatos = [...value.contatos];
                          const realIdx = value.contatos.findIndex((c: any) => c === contato);
                          if (realIdx !== -1) {
                            newContatos[realIdx].valor = v;
                            onChange({ ...value, contatos: newContatos });
                          }
                        }}
                      />
                    )}
                  </div>

                  <BotaoPerigoso
                    icon={mdiTrashCan}
                    variant="none-danger"
                    onClick={() => {
                      // Marca o contato para exclusão em vez de removê-lo da lista
                      const newContatos = [...value.contatos];
                      const realIdx = value.contatos.findIndex((c: any) => c === contato);
                      if (realIdx !== -1) {
                        newContatos[realIdx] = { ...newContatos[realIdx], _paraExclusao: true };
                        onChange({ ...value, contatos: newContatos });
                      }
                    }}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </GridItem>

      <GridItem sm={12}>
        <CampoMemo
          instanceId="obs"
          label="Notas / Observações"
          value={value?.obs ?? ''}
          onChange={v => onChange({ ...value, obs: v })}
          error={fieldErrors?.obs}
        />
      </GridItem>

      {qCustomize.data?.length > 0 && (
        <GridItem sm={12}>
          <div style={{ marginTop: '12px' }}>Campos personalizados</div>
          <Grid>
            {qCustomize.data?.map((it: any) => (
              <GridItem sm={12} md={6}>
                <CampoPersonalizacao
                  label={it.rotulo}
                  type={it.tipo}
                  value={value?.metadados?.[it.nome] ?? ''}
                  onChange={(v: any) => {
                    onChange({
                      ...value,
                      metadados: {
                        ...value.metadados,
                        [it.nome]: v,
                      },
                    });
                  }}
                />
              </GridItem>
            ))}
          </Grid>
        </GridItem>
      )}
    </Grid>
  );
};
